import { useState } from "react";
import { Alan, Secim } from "@kantin/ui";
import type { Urun } from "./kancalar.js";
import { urunSecenekleri } from "./kancalar.js";
import { urunleriSuz } from "./urunArama.js";

/** Enter yalnızca ürünü seçer; içinde bulunduğu formu göndermez. */
export function UrunSecimi({
  etiket,
  urunler,
  deger,
  degistir,
  pasif = false,
}: {
  etiket: string;
  urunler: Urun[] | undefined;
  deger: string;
  degistir: (id: string) => void;
  pasif?: boolean;
}) {
  const [arama, setArama] = useState("");
  const [mesaj, setMesaj] = useState("");
  const sonuclar = urunleriSuz(urunler ?? [], arama);
  const secili = urunler?.find((u) => u.id === deger);
  // Arama mevcut satırın seçimini sessizce değiştirmemeli.
  const secenekler = secili && !sonuclar.includes(secili)
    ? [secili, ...sonuclar]
    : sonuclar;
  const sec = (id: string) => {
    degistir(id);
    setArama("");
    setMesaj("");
  };

  return (
    <div className="flex min-w-0 flex-col gap-1.5">
      <Alan
        etiket={`${etiket} ara`}
        type="search"
        placeholder="Ürün adı veya barkod"
        ipucu="Barkodu okutun veya ad yazın. Tek sonucu Enter ile seçin."
        value={arama}
        disabled={pasif}
        autoComplete="off"
        onChange={(e) => {
          setArama(e.target.value);
          setMesaj("");
        }}
        onKeyDown={(e) => {
          if (e.key !== "Enter") return;
          e.preventDefault();
          e.stopPropagation();
          if (!arama.trim()) return;
          if (sonuclar.length === 1) sec(sonuclar[0]!.id);
          else setMesaj(sonuclar.length
            ? "Birden fazla ürün bulundu; listeden seçin."
            : "Ürün bulunamadı.");
        }}
      />
      <Secim
        etiket={etiket}
        value={deger}
        onChange={(e) => sec(e.target.value)}
        disabled={pasif}
        secenekler={urunSecenekleri(secenekler)}
      />
      {(mesaj || (arama.trim() && sonuclar.length === 0)) && (
        <p role="status" className="m-0 text-xs text-murekkep-2">
          {mesaj || "Ürün bulunamadı."}
        </p>
      )}
    </div>
  );
}
